import { render, staticRenderFns } from "./SurplusTreatyMasterListFormat.vue?vue&type=template&id=b2025678&"
import script from "./SurplusTreatyMasterListFormat.vue?vue&type=script&lang=js&"
export * from "./SurplusTreatyMasterListFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports